




































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import type { CompanyData } from '@/models/companyData';
import { ViewType } from '@/components/prine/enums/ViewType';
import { companyWebservice } from '@/webservices/company';
import CloneDataModal from '@/components/system/companies/CloneDataModal.vue';
import { isSuperAdminNavigationGuard } from '@/helpers/auth/permissionHelpers';
import type { User } from '@/models/user';

@Component({
    name: 'CompaniesList',
    components: {
        CloneDataModal,
    },
})
export default class CompaniesList extends Vue {
    private ViewType = ViewType;
    private viewState: ViewType = ViewType.List;
    private tableSettings = {
        perPage: 15,
        isStriped: true,
        isHoverable: true,
        isPaginated: false,
    };

    private isSendingEmail: boolean = false;
    private isCloneDataModalActive: boolean = false;
    private selectedCompany: CompanyData = {} as CompanyData;

    @Getter('account/userInfo') private userInfo: User;
    @Getter('company/companies') private companies: CompanyData[];
    @Action('company/fetchAllCompanies') private fetchAllCompanies;
    // Mounted is called initially
    private mounted() {
        isSuperAdminNavigationGuard(this.userInfo);
        this.updateCompanies();
    }

    private toggleCloneDataModal(company: CompanyData) {
        this.selectedCompany = company;
        this.isCloneDataModalActive = !this.isCloneDataModalActive;
        this.updateCompanies();
    }

    private toggleGridAndListView() {
        if (this.viewState === ViewType.Grid) {
            this.viewState = ViewType.List;
        } else {
            this.viewState = ViewType.Grid;
        }
    }

    private isViewActive(view: ViewType) {
        if (this.viewState === view) {
            return 'is-active';
        }
    }

    private sendInviteEmailToAdmin(company: CompanyData) {
        this.isSendingEmail = true;
        companyWebservice
            .sendInviteEmailToAdmin(company)
            .then((response) => {
                this.$buefy.toast.open({
                    duration: 5000,
                    message: this.$t('toastMessages.store.email').toString(),
                    type: 'is-success',
                });
                this.isSendingEmail = false;
                this.updateCompanies();
            })
            .catch((error) => {
                this.isSendingEmail = false;
                console.log(error);
            });
    }

    private updateCompanies() {
        this.fetchAllCompanies();
        if (this.companies.length > 15) {
            this.tableSettings.isPaginated = true;
        }
    }
}
